import BalanceCellRenderer from './BalanceCellRenderer'
import messageResource from '../../../../messageResource'
import _ from 'underscore'

function PTOCellRenderer() {
    this.constructor = PTOCellRenderer;
}

PTOCellRenderer.prototype = _.create(BalanceCellRenderer.prototype, {
    getCellGeneralClassName: function() {
        return BalanceCellRenderer.prototype.getCellGeneralClassName.call(this) + " ptoCell";
    },

    roundBalance: function() {
        return window.SystemSettings.roundPTOBalanceOnUserlist;
    },

    getFlagValue: function(value) {
        return value.pto;
    },

    getCurrentBalanceFromValue: function(value) {
        return value.currentPTOBalance;
    },

    showBalanceInHours: function() {
        return window.SystemSettings.showPTOInHours;
    },

    getNotStartedText: function() {
        return messageResource.getEscapedMessage("userlist.js.table.ptoCell.not_started");
    }
});

export default PTOCellRenderer



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/PTOCellRenderer.js